/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_OthersInputs */

const en_mk_cmp_page_others = /** @type {(inputs: Mk_Cmp_Page_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other comparisons`)
};

const id_mk_cmp_page_others = /** @type {(inputs: Mk_Cmp_Page_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbandingan lain`)
};

/**
* | output |
* | --- |
* | "Other comparisons" |
*
* @param {Mk_Cmp_Page_OthersInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_others = /** @type {((inputs?: Mk_Cmp_Page_OthersInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_OthersInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_others(inputs)
	return en_mk_cmp_page_others(inputs)
});